module.exports = __webpack_public_path__ + "img/KIA.39331b3d.png";